import React from 'react';
import { isFlexGapSupported } from './stack-utils';

type Props = {
  gap: number;
  children: React.ReactNodeArray | React.ReactNode;
  direction?: 'row' | 'column';
  style?: React.CSSProperties;
  className?: string;
};

const DIRECTION_TO_MARGIN = {
  row: 'marginRight',
  column: 'marginBottom',
};

export function Stack({ direction = 'column', style, ...props }: Props) {
  const marginDirection = DIRECTION_TO_MARGIN[direction];

  return (
    <div
      className={props.className}
      style={{
        ...style,

        display: 'flex',
        flexDirection: direction,
        ...(isFlexGapSupported && { gap: props.gap }),
        ...(!isFlexGapSupported && { [marginDirection]: props.gap }),
      }}
    >
      {props.children}
    </div>
  );
}
